import { useContext, useEffect, useRef } from 'react'
import { RoomContext, RoomContextType } from '../RoomContext'
import { logger } from './Logger'
import useAudioEngineActions from '../actions/useAudioEngineActions'
import { IAudioEngineRoom } from '../core/AudioEngine'

const log = logger.createChildLogger({ name: 'AudioEngineRoomController' })

export default function useAudioEngineRoomService() {
    const { state: roomState } = useContext(RoomContext) as RoomContextType

    const audioEngineRoomRef = useRef<IAudioEngineRoom>()

    const { joinAudioEngineRoom } = useAudioEngineActions()

    useEffect(() => {
        if (roomState.roomUrn) {
            joinAudioEngineRoom(roomState.roomUrn).then((result) => {
                let [_, audioEngineRoom] = result
                audioEngineRoomRef.current = audioEngineRoom
            })
        }

        return () => {
            if (roomState.roomUrn && audioEngineRoomRef.current) {
                audioEngineRoomRef.current.destroy(roomState.roomUrn)
            }
        }
    }, [roomState.roomUrn])

    return {}
}
